

















import { Component, Vue, Prop, State } from 'nuxt-property-decorator'
import isEmpty from 'lodash/isEmpty'

@Component
export default class CurrentDestination extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @Prop({ default: () => null }) info!: any

  get isValid() {
    return !isEmpty(this.info)
  }

  get spm() {
    if (!this.isValid) {
      return {}
    }

    const ext: any = {
      ...(this.info?.track_info || {})
    }
    const { city_id, country_id } = this.info || {}

    if (city_id) {
      ext.city_id = city_id
    }

    if (country_id) {
      ext.country_id = country_id
    }

    return `Recommendation_LIST?idx=0&len=1&ext=${encodeURIComponent(JSON.stringify(ext))}`
  }
}
